$(function () {
    $('[data-toggle="tooltip"]').tooltip();

    class RapportDatatableBase {
        constructor(api, row, data) {
            this.api = api;
            this.row = row;
            this.data = data;
        }
        // Méthode commune pour les datatables qui gère le rendu des événements ouverts
        render_evenement_ouverts() {
            if (this.data.nb_evenements_ouverts > 1) {
                $(this.row).css('background', 'yellow');
                $(this.row).attr("data-evenements_lies", 'true');
            }
            $(this.row).attr('data-est_transferable_vers_fiche', this.data.est_transferable_vers_fiche);
        }

    }
    class RapportDatatable extends RapportDatatableBase{
        render_colonnes_mes_routes_inspection(row, data) {
            this.api.columns().every(function (colIdx) {
                const col = this.settings()[0].aoColumns[colIdx];
                if (col.name === 'id_ue') {
                    const cell = $('td', row).eq(colIdx);
                    cell.html(`<a href="${data.id_ue_explorateur_url}" target="_blank">${data.id_ue}</a>`);
                }
            });
            super.render_evenement_ouverts(row, data);
        }
        render_colonnes_taj() {
            super.render_evenement_ouverts();
       }
    }
    window.RapportDatatable = RapportDatatable;

});

// cette fonction est appelée au chargement de gestion-rapport.js
function initRapport() {
    // ne pas initialiser les sections de rapport si on a des onglets (comme pour Administration), car ce sera fait à mesure au chargement de chaque onglet
    if ($('#administration_onglets:visible').length > 0) return;
    initRapportSectionsVisibles();
}

// cette fonction peut être appelée de n'importe où, mais l'est entre autres par initRapport() si on n'est pas dans le menu Administration
function initRapportSectionsVisibles() {
    $('.section-rapport:visible').each(function () {
        let idRapport = parseInt($(this).children('[name=hid-id-rapport]').val());
        if (idRapport === RAPPORT.revisions_administrative) return;
        if (idRapport === RAPPORT.analyse_revenu) {
            $(this).find('.sub-tab').each(function (){
                initRapportSection($(this));
            });
        } else {
            initRapportSection($(this));
        }
    });

    $('.section-rapport:visible').each(function () {
        var rapportAttributsJson = $(this).find('[name="hid-rapport-attributs"]').val();
        var rapportAttributs = JSON.parse(rapportAttributsJson);

        if (rapportAttributs.bool_charger_donnees) {
            var tableFiltres = $(this).find('.table-filtres');

            setTimeout(function () {
                var boutonAppliquerFiltre = tableFiltres.closest('.filtre-panneau').find('.appliquer-filtre');
                boutonAppliquerFiltre.click();
            }, 500);
        }
    });
}

function toggleClassSelected(row) {
    if (row.hasClass('selected')) {
        row.removeClass('selected');
    } else {
        row.closest('table').find('tr.selected').removeClass('selected');
        row.addClass('selected');
    }
}

function initRapportSection(sectionElem) {
    wait.start();

    var idRapport = parseInt(sectionElem.find('[name=hid-id-rapport]').val());
    var idRapportGroupe = sectionElem.find('[name=hid-id-rapport-groupe]').val();
    var filtresDefJson = sectionElem.find('[name="hid-filtres-def"]').val();
    var columnsDefJson = sectionElem.find('[name="hid-columns-def"]').val();
    var rapportAttributsJson = sectionElem.find('[name="hid-rapport-attributs"]').val();
    var tableFiltres = sectionElem.find('.table-filtres');

    var tableElem = sectionElem.find('.table-evenements');

    var filtres = $.extend(true, {}, listeFiltresRapport);
    mergeFiltresAvecJson(filtres, filtresDefJson);
    tableElem.data('filtres', filtres);
    tableElem.data('table-filtres', tableFiltres);
    tableElem.data('id-rapport', idRapport);
    tableFiltres.data('table-elem', tableElem);
    var tableTemplate = tableElem.closest('.table-template');

    var columnsDef = JSON.parse(columnsDefJson);
    for (let i = 0; i < columnsDef.length; i++) {
        if (columnsDef[i].render) {
            var runStr = columnsDef[i].render;
            columnsDef[i].render = new Function("data", "type", "row", runStr);
        }
    }

    var columnsDefAsg = $.extend(true, {}, columnsDef);
    tableElem.data('colonnesDef', columnsDefAsg);
    var rapportAttributs = JSON.parse(rapportAttributsJson);

    var order = [];

    if (idRapport == 24 || idRapport == 23) {
        $('.btn-creer-route-inspection').off("click").on("click", function () {
            var url = $(this).data('url');
            var $modalContainer = $('.modal-container');
            var success_cb = function(resp) {
                $modalContainer.find('#modal-route-inspection').empty();
                $modalContainer.find('#modal-route-inspection').remove();
                $modalContainer.append(resp);
                $modalContainer.find('#modal-route-inspection').modal('show');
                initFormRouteInspection();
            };
            call_ajax(url, 'GET', undefined, success_cb);
        });
    }
    else if (idRapport == RAPPORT.equilibration) {
        let btnCalculerCouts = $('button[name=btn-calculer-cout]');
        btnCalculerCouts.off('click').on('click', function () {
            const idTypeEvenement = 41;
            let params = {};
            const tableElem = $('#table-evenements-25');
            buildFiltresSelectionContenu(tableElem);
            let filtres = tableElem.data('filtres');
            if (filtres) {
                filtres = epurerListeFiltresPost(filtres);
                params.listeFiltres = JSON.stringify(filtres);
            }
            tenueAJourModal.ouvrirWizardNouvelEvenement(idTypeEvenement, params);
        });
        let btnCalculerTerrains = $('button[name=btn-calculer-terrain]');
        btnCalculerTerrains.off('click').on('click', function () {
            const idTypeEvenement = 42;
            let params = {};
            const tableElem = $('#table-evenements-25');
            buildFiltresSelectionContenu(tableElem);
            let filtres = tableElem.data('filtres');
            if (filtres) {
                filtres = epurerListeFiltresPost(filtres);
                params.listeFiltres = JSON.stringify(filtres);
            }
            tenueAJourModal.ouvrirWizardNouvelEvenement(idTypeEvenement, params);
        });
        let btnCalculerValeurRetenue = $('button[name=btn-calculer-valeur-retenue]');
        btnCalculerValeurRetenue.off('click').on('click', function () {
            const idTypeEvenement = 43;
            let params = {};
            const tableElem = $('#table-evenements-25');
            buildFiltresSelectionContenu(tableElem);
            let filtres = tableElem.data('filtres');
            if (filtres) {
                filtres = epurerListeFiltresPost(filtres);
                params.listeFiltres = JSON.stringify(filtres);
            }
            tenueAJourModal.ouvrirWizardNouvelEvenement(idTypeEvenement, params);
        });
        let btnCalculerRepartitionFiscale = $('button[name=btn-calculer-repartition-fiscale]');
        btnCalculerRepartitionFiscale.off('click').on('click', function () {
            const idTypeEvenement = 44;
            let params = {};
            const tableElem = $('#table-evenements-25');
            buildFiltresSelectionContenu(tableElem);
            let filtres = tableElem.data('filtres');
            if (filtres) {
                filtres = epurerListeFiltresPost(filtres);
                params.listeFiltres = JSON.stringify(filtres);
            }
            tenueAJourModal.ouvrirWizardNouvelEvenement(idTypeEvenement, params);
        });
        let btnCalculerComparaison = $('button[name=btn-calculer-comparaison]');
        btnCalculerComparaison.off('click').on('click', function () {
            const idTypeEvenement = 45;
            let params = {};
            const tableElem = $('#table-evenements-25');
            buildFiltresSelectionContenu(tableElem);
            let filtres = tableElem.data('filtres');
            if (filtres) {
                filtres = epurerListeFiltresPost(filtres);
                params.listeFiltres = JSON.stringify(filtres);
            }
            tenueAJourModal.ouvrirWizardNouvelEvenement(idTypeEvenement, params);
        });
        let btnCalculerEquilibrationFacteur = $('button[name=btn-calculer-equilibration-facteur]');
        btnCalculerEquilibrationFacteur.off('click').on('click', function () {
            const idTypeEvenement = 46;
            let params = {};
            const tableElem = $('#table-evenements-25');
            buildFiltresSelectionContenu(tableElem);
            let filtres = tableElem.data('filtres');
            if (filtres) {
                filtres = epurerListeFiltresPost(filtres);
                params.listeFiltres = JSON.stringify(filtres);
            }
            tenueAJourModal.ouvrirWizardNouvelEvenement(idTypeEvenement, params);
        });
        let btnCalculerCoutVente = $('button[name=btn-calculer-cout-vente]');
        btnCalculerCoutVente.off('click').on('click', function () {
            const idTypeEvenement = 47;
            let params = {};
            let id_rapport = $('.section-rapport:visible').find('[name=hid-id-rapport]').val();
            const tableElem = $(`#table-evenements-${id_rapport}`);
            buildFiltresSelectionContenu(tableElem);
            let filtres = tableElem.data('filtres');
            if (filtres) {
                filtres = epurerListeFiltresPost(filtres);
                params.listeFiltres = JSON.stringify(filtres);
            }
            tenueAJourModal.ouvrirWizardNouvelEvenement(idTypeEvenement, params);
        });
        let btnCalculerRevenu = $('button[name=btn-calculer-revenu]');
        btnCalculerRevenu.off('click').on('click', function () {
            const idTypeEvenement = 48;
            let params = {};
            const tableElem = $('#table-evenements-25');
            buildFiltresSelectionContenu(tableElem);
            let filtres = tableElem.data('filtres');
            if (filtres) {
                filtres = epurerListeFiltresPost(filtres);
                params.listeFiltres = JSON.stringify(filtres);
            }
            tenueAJourModal.ouvrirWizardNouvelEvenement(idTypeEvenement, params);
        });
        let btnImporterValeurImmeubleExcel = $('button[name=btn-importer-valeurs-equilibration-roles-excel]');
        btnImporterValeurImmeubleExcel.off('click').on('click', function () {
            const idTypeEvenement = 55;
            let params = {};
            let id_rapport = $('.section-rapport:visible').find('[name=hid-id-rapport]').val();
            const tableElem = $(`#table-evenements-${id_rapport}`);
            buildFiltresSelectionContenu(tableElem);
            let filtres = tableElem.data('filtres');
            if (filtres) {
                filtres = epurerListeFiltresPost(filtres);
                params.listeFiltres = JSON.stringify(filtres);
            }
            tenueAJourModal.ouvrirWizardNouvelEvenement(idTypeEvenement, params);
        })
    }

    var fct_importer_data = function (detruireTable) {
        var colonnesDef = tableElem.data('colonnesDef');
        var select = [15, 17].includes(idRapport);
        var headerFixe = rapportAttributs.bool_header_fixe;
        var footerTotal = rapportAttributs.bool_footer_total;
        var sectionApres = [15, 17].includes(idRapport);
        var impressionPdf = rapportAttributs.bool_impression_pdf;
        var chargerDonnees = detruireTable;
        var pageLength = 25;
        if ($('#query-builder').length != 0) {
            pageLength = 10;
        }
        var url;
        switch (true) {
            case idRapport == RAPPORT.vfe:
                url = '/gestion-entreprise/gestion-rapport/charger_vfe/';
                break;
            case idRapport == RAPPORT.releve_temps_depenses:
                url = '/gestion-entreprise/gestion-rapport/charger_releve_temps_depenses/';
                break;
            default:
                url = '/gestion-entreprise/gestion-rapport/charger/';
        }

        var table = tableElem.on('processing.dt', function (e, settings, processing) {
            wait.processing(processing, '', '', 0);
        });
        var headerOffsetInt = $('.navbar-fixed-top').outerHeight();
        if ($(".widget-fixtop").length) {
            headerOffsetInt += $('.widget-fixtop').outerHeight();
            headerOffsetInt += 15;
        }
        table = initTableDatatable(tableElem, {
            ajax: {
                url: url,
                data: function (d) {
                    d.id_rapport = idRapport;

                    buildFiltresSelectionContenu(tableElem);

                    var listeFiltresDef = tableElem.data('filtres');
                    var listeFiltres = epurerListeFiltresPost(listeFiltresDef);
                    d.listeFiltres = JSON.stringify(listeFiltres);
                    d.colonnesDef = JSON.stringify(colonnesDef);
                    d.id_municipalite = $('#adm-liste-ville').val();
                    if ($('#query-builder').length != 0) {
                        var listeFiltresQueryBuilder = $('#query-builder').queryBuilder('getSQL', false, true);
                        d.listeFiltresQueryBuilder = JSON.stringify(listeFiltresQueryBuilder, null, 2);
                        d.idMunicipalite = $("#id_municipalite_sig").val();
                    }
                },
                type: "POST"
            },
            async: false,
            destroy: detruireTable,
            dom: '<"datatables-top-pagination"li>T<"datatables-menu-actions">Bfrtip',
            buttons: [
                'colvis',
                'colvisRestore',
            ],
            fixedHeader: {
                headerOffset: headerOffsetInt
            },
            info: 'Affichage des &eacute;v&eacute;nements _START_ &agrave; _END_ sur _TOTAL_',
            infoCallback: function (settings, start, end, max, total, pre) {
                if (total == 0) {
                    return pre;
                } else {
                    let json = table.ajax.json();
                    if (json.elapsed != '') {
                        return `${pre} (${json.elapsed})`;
                    } else {
                        return pre;
                    }
                }
            },
            order: order,
            paging: true,
            deferLoading: (chargerDonnees ? null : 0),
            pageLength: pageLength,
            processing: false,
            responsive: false,
            scrollCollapse: true,
            scrollX: true,
            scrollY: '70vh',
            searching: false,
            serverSide: true,
            tableTools: {
                "aButtons": ["excel"]
            },
            columnDefs: columnsDef,
            select: select,
            createdRow: function (row, data) {
                idRapport = parseInt(idRapport);
                const dtClass = new window.RapportDatatable(this.api(), row, data);

                if (idRapport === 15) {
                    $(row).attr("data-id_ligne_feuille_temps_depense", data.id_ligne_feuille_temps_depense);
                }
                if (idRapport === 17) {
                    $(row).attr("data-id_transaction_comptable", data.id_transaction_comptable);
                }
                if (idRapport === 18) {
                    $(row).attr("data-id_ue", data.id_ue);
                    $(row).attr("data-id_municipalite", data.id_municipalite);
                    $(row).attr("data-matricule", data.matricule);
                }
                if (idRapport === 22) {
                    $(row).attr("data-id_municipalite", data.id_municipalite);
                }
                if (idRapport === RAPPORT.mes_routes_inspection) {
                    dtClass.render_colonnes_mes_routes_inspection(row, data);
                }
                if (idRapport === RAPPORT.tenue_a_jour) {
                    dtClass.render_colonnes_taj();
                }

                if (idRapportGroupe == 10 || idRapport === 60) {
                    if (data.bool_validation_terrain_equilibration === true) {
                        $(row).find('td .check-valider-terrain').prop('checked', true);
                    }
                    if (data.bool_validation_immeuble_equilibration === true) {
                        $(row).find('td .check-valider-immeuble').prop('checked', true);
                    }
                    $(row).find('td.nowrap').each(function () {
                        let sTitle = $(this).text();
                        this.setAttribute('title', sTitle);
                    });
                }

                if (idRapport === RAPPORT.mise_a_jour_sig) {
                    if (data.bool_maj_sig_complete === true) {
                        $(row).find('td .check-sig-complete').prop('checked', true);
                    }
                }

                if (idRapport === RAPPORT.regroupement) {
                    $(row).attr('data-bool_regroupement_base', data.bool_regroupement_base);
                    $(row).attr('data-bool_read_only', data.bool_read_only);
                }

                $(row).attr("id", data.id_evenement);
                $(row).attr("data-id_evenement", data.id_evenement);
                $(row).attr("data-id_ue", data.id_ue);
                $(row).attr("data-id_type_evenement", data.id_type_evenement);
                $(row).attr("data-etape", data.id_etape_processus);
                $(row).attr("data-id_municipalite", data.id_municipalite);
                $(row).attr("data-date_evenement", data.date_evenement);
                $(row).attr("data-id_statut_evenement", data.id_statut_evenement);
                $(row).attr("data-bool_visible", data.bool_visible);

                $(row).attr("data-id_projet", data.id_projet);
                $(row).attr("data-id_lot", data.id_lot);
                $(row).attr("data-id_sous_lot", data.id_sous_lot);
                $(row).attr("data-id_employe", data.usager_id);
            },
            initComplete: function (settings, json) {
                const keyLocalStorage = getKeyLocalStorage(settings.nTable)
                getNbrColonneMasquees(keyLocalStorage);
                tableElem.find('tbody').on('click', '.check-taj', function () {
                    tenueAJour.cliquerCaseCocherLigneEvenement(this, table);
                });

                tableElem.closest('.table-template').find('.datatables-menu-actions').on('click', '[name=check-tj-select-all]', function () {
                    var boutonsActionDisabled = controlesFormulaires.selectAll(tableElem, $(this));
                    var conteneur = $(this).closest('.table-template');
                    tenueAJour.activerDesactiverBoutonsRuban(conteneur, boutonsActionDisabled);
                });


                if (!headerFixe) {
                    return;
                }

                var accordeonFiltres = $("[id='accordion filtre-panneau']");

                tableElem.closest('.table-template').find('.dataTables_scrollBody').css({
                    'overflow': 'auto',
                    'border': '0'
                });

                tableElem.closest('.dataTables_wrapper').addClass("table-scroller-custom");

                $(".table-scroller-custom .dataTables_scrollBody").scroll(function () {
                    $(this).closest(".table-scroller-custom").find(".dataTables_scrollHead").css({
                        'left': -$(this).scrollLeft()
                    });
                });

                /* évite des erreurs le calcul pour la taille des tableaux lors du fade de tabs bootstrap qui fait .15s */
                if(tableElem.closest(".section-rapport.tab-pane.fade").length) {
                    setTimeout(function () {
                        table.columns.adjust();
                    }, 150);
                }
            },
            headerCallback: function (thead, data, start, end, display) {
                tableTemplate.find(".datatables-menu-actions").load("/gestion-roles/tenue-a-jour/evenements/actions-sur-table/?" + $.param({
                    id_rapport: idRapport
                }),
                    function () {
                        bootstrapOn.initTooltips();
                        var conteneur = $(this);
                        var disabled = table.data().count() <= 0;

                        // Sans résultat dans un tableau de rapport, on désactive les boutons
                        if (parseInt(idRapport) === RAPPORT.evenement_en_cours && !disabled) {
                            $(".btn-tj-exporter-excel").prop('disabled', false);
                        } else {
                            $(".btn-tj-exporter-excel").prop('disabled', true);
                        }

                        var btnImprimer = conteneur.find('[name=btn-tj-imprimer]');
                        if (!impressionPdf) {
                            btnImprimer.hide();
                        } else {
                            btnImprimer.prop("disabled", true);

                            if (![RAPPORT.tenue_a_jour, RAPPORT.mes_routes_inspection].includes(parseInt(idRapport))) {
                                var html = btnImprimer.html().replace('Imprimer', 'PDF'); // HACK rapide !
                                btnImprimer.html(html);
                            }
                        }

                        //Désactive tous les boutons
                        conteneur.find('.checkall-taj').parent().children().hide();
                        conteneur.find('.checkall-taj').show();
                        conteneur.find('.checkall-taj span').html("Sélectionner tout");

                        if ([RAPPORT.gestion_route, RAPPORT.tenue_a_jour, RAPPORT.mes_routes_inspection].includes(parseInt(idRapport))) {
                            conteneur.find('.checkall-taj').show();
                            conteneur.find('[name=btn-tj-supprimer]').show();
                        }
                        if ([55, 56, 57, 76].includes(idRapport)) {
                            conteneur.find('[name=rafraichir-donnees]').show();
                        }

                        if ([RAPPORT.tenue_a_jour, RAPPORT.revisions_administrative, RAPPORT.mes_routes_inspection].includes(parseInt(idRapport))) {
                            conteneur.find('[name=btn-tj-assigner-et-etat]').show();
                            conteneur.find('[name=btn-tj-date-inspection]').show();
                            conteneur.find('[name=btn-mode-deconnecte]').show();
                            conteneur.find('[name=btn-tj-afficher-dans-explorateur]').show();
                            conteneur.find('[name=btn-tj-change-priorite]').show();
                            conteneur.find('[name=btn-tj-change-regime-fiscal]').show();

                        }
                    });
            },
            footerCallback: function (row, data, start, end, display) {

                if (!footerTotal) return;

                var columns = table.settings().init().aoColumnDefs;

                table.columns().every(function (index) {

                    var nom_colonne = (data.length > 0 ? columns[index].name : null);
                    var valeurTot = (data.length > 0 ? data[0]['total_' + nom_colonne] : null);
                    var cellFooter = $(table.column(index).footer());

                    cellFooter
                        .empty()
                        .removeClass('d-flex rowflex-space-between');

                    if (nom_colonne === 'id_projet') {
                        cellFooter.text('TOTAL:');
                        return;
                    }

                    if (typeof valeurTot === 'undefined' || valeurTot === null || isNaN(parseFloat(valeurTot))) {
                        return;
                    }

                    var valeurAffichee;
                    if (cellFooter.hasClass('datatable-num-val-2')) {
                        valeurAffichee = $.fn.dataTable.render.number('\u00A0', '.', 2, '').display(valeurTot);
                    } else if (nom_colonne !== 'delai_moyenne_evenement') {
                        valeurAffichee = $.fn.dataTable.render.number('\u00A0', '.', 0, '').display(valeurTot);
                    } else {
                        valeurAffichee = valeurTot;
                    }
                    var $wrapper = $('<div/>', {
                      class: 'align-right'
                       });

                    if (idRapport === 74 &&
                        (nom_colonne === 'nb_attestation_verification_tous' ||
                            nom_colonne === 'nb_inspection_complete' ||
                            nom_colonne === 'nb_heures_even')) {

                        const typeAttestation = (nom_colonne === 'nb_attestation_verification_tous') ? 0 : 1;

                        var title;

                        var $linkTotal = '';

                        if (nom_colonne === 'nb_attestation_verification_tous' || nom_colonne === 'nb_inspection_complete') {
                            title = nom_colonne === 'nb_attestation_verification_tous' ? "Exporter en excel le total des attestations" : "Exporter en excel le total des attestations complète";

                            $linkTotal = $('<a/>', {
                                href: '#',
                                title: title,
                                class: 'row-hyperlien margin-right-02',
                                click: function (e) {
                                    e.preventDefault();
                                    details_liste_attestation_clicked(this, typeAttestation);
                                }
                            }).html(valeurAffichee);

                        } else if (nom_colonne === 'nb_heures_even') {
                            $linkTotal = $('<a/>', {
                                href: '#',
                                title: 'Voir le détail',
                                class: 'row-hyperlien',
                                click: function (e) {
                                    e.preventDefault();
                                    delais_traitement_heures_clicked(this, true);
                                }
                            }).html(valeurAffichee);
                        }
                        $wrapper.append($linkTotal);

                    } else {
                        $wrapper.append(valeurAffichee);
                    }

                    cellFooter.append($wrapper);
                });
            },
            drawCallback: function (response) {
                if (response.json) {
                    if (response.json.reponse) {
                        infos.ajouterMessageToast({
                            message: response.json.reponse,
                            messageDuree: 5000
                        });
                    }
                }

                initAceThumbnails('colorbox-photo-rapport');

                var listeImg = tableElem.find('img');
                listeImg.attr('height', '40px');
                $('[name="ajustement-apres-body"]').html('');
                $('.btn-reactivate-formulaire, .btn-desassigner-citoyen').on('click', function () {
                    const url = $(this).data('url');
                    const success_cb = function () {
                      $('.appliquer-filtre').click();
                    };
                    call_ajax(url, 'GET', null, success_cb);
                });
            }
        });
        // On sélectionne et désélectionne des évènements dans la grille par clic sur la rangée (CTRL, MAJ).
        table
            .on('select', function (e, dt, type, indexes) {
                var $selecteur = $(this);
                var checked = true;
                tenueAJour.activerActionsSurEvenementGrille($selecteur, checked, indexes);
            })
            .on('deselect', function (e, dt, type, indexes) {
                var $selecteur = $(this);
                var checked = false;
                tenueAJour.activerActionsSurEvenementGrille($selecteur, checked, indexes);
            });

        tableElem.find('tbody').off('click', 'tr').on('click', 'tr', function () {
            var row = $(this);
            if (!sectionApres) return
            var id_ligne_feuille_temps_depense = row.attr("data-id_ligne_feuille_temps_depense");
            var id_transaction_comptable = row.attr("data-id_transaction_comptable");
            var params = {
                id_rapport: idRapport,
                id_ligne_feuille_temps_depense: id_ligne_feuille_temps_depense,
                id_transaction_comptable: id_transaction_comptable
            }

            wait.start();

            $.ajax({
                type: "GET",
                url: '/gestion-entreprise/gestion-ajustement/ouvrir-apres/',
                data: params,
                dataType: 'html',
                success: function (response) {
                    var container = $('[name="ajustement-apres-body"]');
                    container.html(response);

                    var inputs = container.find('[name=lot],[name=sousLot],[name=categorieItemCout]');
                    inputs.data('callback-params-supp', getTempsDepenseSelect2Params);

                    initMenuBlocs();

                    // calculer automatiquement les totaux de ces colonnes dans la première ligne qui est readonly
                    var colonnesTotal = ['jour1', 'jour2', 'jour3', 'jour4', 'jour5', 'jour6', 'jour7', 'pourboire',
                        'debit', 'credit', 'honoraires', 'debourses', 'profit_restriction', 'facturation', 'coutant'];
                    var valeursTotal = {};

                    var lignes = container.find('.sous-bloc-form');
                    var premiereLigne = lignes.filter(':eq(0)');

                    var derniereLigne = lignes.filter(':eq(1)');

                    premiereLigne.find('.form-control').each(function () {
                        var nom = $(this).attr('name');
                        if (colonnesTotal.includes(nom)) {
                            $(this).addClass('input-disabled').prop("readonly", true).prop("disabled", true)
                            if ($(this).val())
                                valeursTotal[nom] = TryParseFloat($(this).val(), 0);
                        }
                    });

                    function recalcTotal(colonne) {
                        var lignes = container.find('.sous-bloc-form').not(premiereLigne);
                        var total = 0;
                        lignes.each(function () {
                            var valeurStr = $(this).find('[name=' + colonne + ']').val();
                            total += TryParseFloat(valeurStr, 0);
                        });

                        var difference = valeursTotal[colonne] - total;
                        difference = Math.round(difference * 100000) / 100000;
                        var inputPremiereLigne = premiereLigne.find('[name=' + colonne + ']');
                        inputPremiereLigne.val(difference > 0 ? difference : '');
                        setTimeout(function () {
                            inputPremiereLigne.change();
                            inputPremiereLigne.removeClass(CLASSE_CONTROLE_MODIFIE);
                        }, 100);
                    }

                    derniereLigne.find('.form-control').each(function () {
                        var nom = $(this).attr('name');
                        if ($.inArray(nom, colonnesTotal) > -1) {
                            $(this).on('change', function () {
                                recalcTotal($(this).attr('name'));
                            });
                        }
                    });

                    $('#btnAjustementSave').off('click').on('click', function () {
                        sauvegarderFeuille({
                            sauvegarde_complet: '1',
                            id_type_temps_depense: $('[name=hid-type-temps-depense]').val(),
                            id_ligne_feuille_temps_depense: $('[name=hid-ligne-feuille-temps-depense]').val(),
                            id_transaction_comptable: $('[name=hid-transaction-comptable]').val()
                        });
                    });

                    wait.stop();
                }
            });
        });

        if (!footerTotal) {
            $('[name=ajustement-apres-body]').html('');

            tableElem.find('tfoot').hide();
            tableElem.find('.datatables-menu-actions').hide();
        }
    };

    tableElem.data('fct-importer-data', fct_importer_data);
    for (let i = 0; i < columnsDef.length; i++) {
        tableTemplate.find('tfoot tr').append('<td></td>');
    }
    chargerFiltresEtDonnees(tableElem, true);

    tableTemplate.off("click", '.btn-tj-exporter-excel').on('click', '.btn-tj-exporter-excel', () => {
        export_xls_taj_rapport(tableElem, '/gestion-entreprise/gestion-rapport/export_xls_rapport/');
    });
    tableTemplate.off("click", '.btn-tj-exporter-gpx').on('click', '.btn-tj-exporter-gpx', function () {
        var selected_rows = tableElem.DataTable().rows('.selected').data();
        var liste_evs = [];
        $.each(selected_rows, function (idx, data) {
            liste_evs.push(data.id_evenement);
        });
        var data = {
            liste_evs: liste_evs,
        };
        var success = function (response) {
            infos.ajouterMessageToast({
                message: response,
                messageDuree: 5000
            });
        };
        wait.start();
        call_ajax($(this).data('url'), 'POST', data, success);
    });
    tableTemplate.off("click", '.btn-tj-exporter-google-map').on('click', '.btn-tj-exporter-google-map', () => {
        export_google_map_taj_rapport(tableElem);
    });
    tableTemplate.off("click", '.btn-inspection-ouvrir-fiche').on('click', '.btn-inspection-ouvrir-fiche', () => {
        inspection_ouvrir_fiche(tableElem);
    });
    tableTemplate.off("click", '.btn-tj-change-priorite').on('click', '.btn-tj-change-priorite', () => {
        wait.start();
        var table = $('.table-evenements').DataTable();
        var muns = new Set();
        $(table.rows('.selected').nodes()).each(function () {
            muns.add($(this).data('id_municipalite'));
        });
        const $modal = $('#modal-change-priorite');
        const url = $modal.data('url');

        const succes_cb = function (resp) {
            const $form_container = $modal.find('.form-container');

            $form_container.empty();
            $form_container.html(resp.template);
            $modal.modal('show');
            let id_evs = [];
            $(table.rows('.selected').nodes()).each(function () {
                id_evs.push($(this).data('id_evenement'));
            });
            let $select = $form_container.find('select#id_id_evenements');
            $select.empty();
            $.each(id_evs, function(index, id) {
                $select.append(new Option(id, id, true, true));
            });
            $('#id_priorite').select2({
                closeOnSelect:false,
                dropdownCssClass: "responsive-select2-drop",
                width: '100%'
            });
            $modal.off('click', '#btn-save-priorite').on('click', '#btn-save-priorite', function () {
                const data = $form_container.find('form').serialize();
                const succes_cb = function (response) {
                    infos.ajouterMessageToast({
                        message: success_msg,
                        icone: 'fa-check-circle-o',
                        iconeCouleur: 'green',
                        messageDuree: 5000
                    });
                    $modal.modal('hide');
                    table.ajax.reload();
                };
                const error_cb = function (xhr) {
                    $form_container.empty();
                    $form_container.html(xhr.responseJSON.template);
                    $('#id_priorite').select2({closeOnSelect:false});
                };
                call_ajax(url, 'POST', data, succes_cb, error_cb);
            });
        };
        const data = {muns: JSON.stringify(Array.from(muns))};
        call_ajax(url, 'GET', data, succes_cb);
    });
    tableTemplate.off("click", '.btn-tj-change-regime-fiscal').on('click', '.btn-tj-change-regime-fiscal', () => {
        wait.start();
        var table = $('.table-evenements').DataTable();
        var muns = new Set();
        $(table.rows('.selected').nodes()).each(function () {
            muns.add($(this).data('id_municipalite'));
        });
        const $modal = $('#modal-change-regime-fiscal');
        const url = $modal.data('url');

        const succes_cb = function (resp) {
            const $form_container = $modal.find('.form-container');
            $form_container.empty();
            $form_container.html(resp.template);
            $modal.modal('show');

            let id_evs = [];
            $(table.rows('.selected').nodes()).each(function () {
                id_evs.push($(this).data('id_evenement'));
            });
            let $select = $form_container.find('select#id_id_evenements');
            $select.empty();
            $.each(id_evs, function(index, id) {
                $select.append(new Option(id, id, true, true));
            });
            $('#id_regime_fiscal').select2({
                closeOnSelect: false,
                dropdownCssClass: "responsive-select2-drop",
                width: '100%'
            });
            $modal.off('click', '#btn-save-regime-fiscal').on('click', '#btn-save-regime-fiscal', function () {
                const data = $form_container.find('form').serialize();
                const succes_cb = function (response) {
                    infos.ajouterMessageToast({
                        message: success_msg,
                        icone: 'fa-check-circle-o',
                        iconeCouleur: 'green',
                        messageDuree: 5000
                    });
                    $modal.modal('hide');
                    table.ajax.reload();
                };
                const error_cb = function (xhr) {
                    $form_container.empty();
                    $form_container.html(xhr.responseJSON.template);
                    $('#id_regime_fiscal').select2({closeOnSelect: false});
                };
                call_ajax(url, 'POST', data, succes_cb, error_cb);
            });
        };
        const data = {muns: JSON.stringify(Array.from(muns))};
        call_ajax(url, 'GET', data, succes_cb);
    });
    tableTemplate.off("click", '.btn-tj-supprimer').on("click", '.btn-tj-supprimer', function () {
        if ([RAPPORT.tenue_a_jour, RAPPORT.mes_routes_inspection].includes(parseInt(idRapport))) {
            tenueAJour.actionsBoutonsRuban($(this));
        } else {
            supprimer_taj_rapport(tableElem, "/gestion-entreprise/gestion-rapport/supprimer_rapport/");
        }
    });

    tableTemplate.off("click", '[data-action]').on("click", '[data-action]', function () {
        var element = $(this).data('action');

        if (element == 'btn-taj-generation-rdv') {
            rdv.taj_ruban_action_rdv_creation_click(element);
        }
        if (element === 'btn-tj-imprimer') {
            if (idRapport == 65) {
                let callback_edition = () => {
                    $('#btn-print-ivu').on('click', () => {
                        wait.start()
                        $.ajax({
                            type: "POST",
                            url: '/gestion-entreprise/gestion-rapport/imprimer_rapport_ivu/',
                            data: $("#modal-rapport-ivu").find('form').serialize(),
                            dataType: 'json',
                            success: function (response) {
                                wait.stop()
                                infos.ajouterMessageToast({
                                    message: response.msg,
                                    icone: 'fa-envelope-o ',
                                    iconeCouleur: 'green',
                                    messageDuree: 5000
                                });
                                fenetreModal.fermerModal("modal-rapport-ivu");
                            }
                        });
                    });
                };

                let ues = [];
                tableElem.find('input:checked').each((e, input) => {
                    ues.push($(input).closest('tr').data('id_ue'));
                });
                var modal_ivu = {
                    id: "modal-rapport-ivu",
                    view: "/core/modal/",
                    id_processus: "",
                    titre: "Impression",
                    titre_supp: "",
                    ue_selectionne: ues,
                    contenuHTML: "",
                    template_view: "/gestion-roles/modal_ivu/",
                    template_depart: "",
                    template_depart_view: "",
                    url: "",
                    taille: "",
                    resultat: "",
                    resultat_depart: "",
                    wizard: false,
                    callback: callback_edition,
                    boutons: [
                        {
                            type: "cancel",
                            label: "Annuler",
                            title: "",
                            classSupp: "",
                            afficher: true
                        },
                        {
                            type: "print",
                            label: "Imprimer",
                            title: "",
                            id: "btn-print-ivu",
                            classSupp: "btn-primary",
                            afficher: true
                        }
                    ]
                };
                setTimeout(function () {
                    fenetreModal.creerModal(modal_ivu, {});
                }, 0);
            } else if (idRapport === RAPPORT.registre_construction) {
                let callback_edition = () => {
                    $('#btn-print-registre').on('click', () => {
                        wait.start()
                        let form = $("#modal-registre-construction").find('form')
                        var rows = tableElem.DataTable().rows('.selected').data()

                        var evenements = [];
                        $.each(rows, function (idx, row) {
                            if (row.id_ue != '') {
                                evenements.push({'id_evenement': row.id_evenement, 'id_batiment': row.id_batiment})
                            }
                        });
                        let data = form.serializeArray()
                        data.push({'name': 'evenements', value: JSON.stringify(evenements)})
                        $.ajax({
                            type: form.attr('method'),
                            url: form.attr('action'),
                            data: data,
                            dataType: 'json',
                            success: function (response) {
                                wait.stop()
                                infos.ajouterMessageToast({
                                    message: response.msg,
                                    icone: 'fa-envelope-o ',
                                    iconeCouleur: 'green',
                                    messageDuree: 5000
                                });
                                fenetreModal.fermerModal("modal-registre-construction");
                            }
                        })
                    })
                }
                var modal_registre = {
                    id: "modal-registre-construction",
                    view: "/core/modal/",
                    id_processus: "",
                    titre: "Impression",
                    titre_supp: "",
                    contenuHTML: "",
                    template_view: "/gestion-roles/modal_registre_construction/",
                    template_depart: "",
                    template_depart_view: "",
                    url: "",
                    taille: "",
                    resultat: "",
                    resultat_depart: "",
                    wizard: false,
                    callback: callback_edition,
                    boutons: [
                        {
                            type: "cancel",
                            label: "Annuler",
                            title: "",
                            classSupp: "",
                            afficher: true
                        },
                        {
                            type: "print",
                            label: "Imprimer",
                            title: "",
                            id: "btn-print-registre",
                            classSupp: "btn-primary",
                            afficher: true
                        }
                    ]
                };
                setTimeout(function () {
                    fenetreModal.creerModal(modal_registre, {});
                }, 0);


            } else if ([RAPPORT.tenue_a_jour, RAPPORT.mes_routes_inspection].includes(parseInt(idRapport))) {
                tenueAJour.actionsBoutonsRuban($(this));
            } else
                export_xls_taj_rapport(tableElem, "/gestion-entreprise/gestion-rapport/imprimer_rapport/");
        }
        if (element === 'btn-tj-afficher-dans-explorateur') {
            afficherTAJDansExplorateur(true);
        }
        if (element === 'rafraichir-donnees') {
            ouvrirModalParametresCalcul($(this));
        }
        if (element === 'btn-tj-assigner-et-etat') {
            tenueAJourModal.modalAssignerEtEtat();
        }
        if (element === 'btn-taj-automatiser-transfert') {
            modalAutomatiserTransfertEnqueteRevenu();
        }
        if (element === 'btn-tj-date-inspection') {

            if (!$('#tenue-a-jour-modal-date-inspection').length) { // si la modal n'a pas déjà été chargé

                var variableDateInspection = {
                    id: "tenue-a-jour-modal-date-inspection",
                    view: "/core/modal/",
                    id_processus: "",
                    titre: "Date Inspection ",
                    titre_supp: "",
                    module: "",
                    contenuHTML: "",
                    template: "",
                    template_view: "/gestion-roles/evenement-date-inspection/",
                    template_depart: "",
                    template_depart_view: "",
                    url: "",
                    taille: "normale",
                    resultat: "",
                    resultat_depart: "",
                    wizard: false,
                    sans_x: true,
                    callback: tenueAJourModal.modalDateInspectionLoaded,
                    boutons: [
                        {
                            type: "cancel",
                            label: "Annuler",
                            title: "",
                            classSupp: "",
                            afficher: true
                        },
                        {
                            type: "save",
                            label: "Sauvegarder",
                            title: "",
                            classSupp: "btn-primary",
                            afficher: true,
                            id: "btn-save-modal-date-inspection",
                            disabled: true
                        }
                    ]
                };

                setTimeout(function () {
                    fenetreModal.creerModal(variableDateInspection, {});
                }, 0);


            } else {
                $('#tenue-a-jour-modal-date-inspection').modal('show');
            }
        }
    });

    init_date_picker(tableFiltres);
    init_dateRangePicker(tableFiltres);
    initEventFiltres(filtres, tableFiltres);

    initSelectDependant(tableFiltres, filtres);

    if ([RAPPORT.equilibration, RAPPORT.mutations, RAPPORT.tenue_a_jour, RAPPORT.mes_routes_inspection, RAPPORT.mise_a_jour_sig].includes(parseInt(idRapport))) {
        var params = {'callback_fermeture_modal': function () {
            refreshDatatables();
        }};
        tenueAJourModalBoutons.initBoutonsTableEvenement(params);
        if ([RAPPORT.tenue_a_jour, RAPPORT.mes_routes_inspection].includes(parseInt(idRapport))) {
            // Évènement - Créer un nouvel évènement.
            $('#btn-tenue-a-jour-modal-creer-evenement').off('click').on('click', function () {
                tenueAJourModal.ouvrirModalCreationEvenement();
            });

            $('.btn-creer-route-inspection').off("click").on("click", function () {
                var url = $(this).data('url');
                var $modalContainer = $('.modal-container');
                var success_cb = function(resp) {
                    $modalContainer.find('#modal-route-inspection').empty();
                    $modalContainer.find('#modal-route-inspection').remove();
                    $modalContainer.append(resp);
                    $modalContainer.find('#modal-route-inspection').modal('show');
                    initFormRouteInspection();
                };
                call_ajax(url, 'GET', undefined, success_cb);
            });
        }
    }
    else if (idRapport == RAPPORT.responsable_execution) {
        tableElem.off('click', 'tr').on('click', 'tr', function (event) {
            var row = $(this);

            if ($(event.target).is('input[type=checkbox]') || $(event.target).prev().is('input[type=checkbox]')) {
                return;
            }

            toggleClassSelected(row);

            if (row.hasClass('selected')) {
                var idProjet = row.attr('data-id_projet');
                var idLot = row.attr('data-id_lot');
                var idSousLot = row.attr('data-id_sous_lot');

                var tableElem = row.closest('.table-evenements');
                var tableFiltres = tableElem.data('table-filtres');

                var tableElem2 = $('.table-evenements[id^=DataTables]').not(tableElem);
                var tableFiltres2 = tableElem2.data('table-filtres');

                var filtresProjet = [{id: idProjet}];
                var filtresLot = [{id: idLot}];
                var filtresSousLot = [{id: idSousLot}];

                setFiltreValeurs(tableElem2, 'projet', filtresProjet);
                setFiltreValeurs(tableElem2, 'lot', filtresLot);
                setFiltreValeurs(tableElem2, 'sous_lot', filtresSousLot);

                var boutonAppliquerFiltre = tableFiltres2.closest('.filtre-panneau').find('.appliquer-filtre');
                boutonAppliquerFiltre.click();
            }
        });

        $('#gestion-ouvrir-ligne').off('click').on('click', function () {
            ouvrirFermerLigne(1, tableElem, '/gestion-entreprise/gestion-responsable-execution/ouvrir-fermer/');
        });
        $('#gestion-fermer-ligne').off('click').on('click', function () {
            ouvrirFermerLigne(0, tableElem, '/gestion-entreprise/gestion-responsable-execution/ouvrir-fermer/');
        });
    }
    else if (idRapport == RAPPORT.rh_absences) {
        $("#btn-modal-absence").on('click', () => {
            $("#modal_absence").modal();
        })
    }
    wait.stop();
}


initRapport();

$('a[href^=#content-btn-rapport-]').off('click').on('click', function (e) {
    var idRapport = $(this).data('id_rapport');
    var sectionElem = $(`#content-btn-rapport-${idRapport}`);
    var idbtnrapport = `btn-rapport-${idRapport}`;

    var tableElem = sectionElem.find('.table-evenements');

    if ($('.tabbable').find(`li:not(.active) > a#${idbtnrapport}`).length > 0) {
        if (tableElem.length == 1) {
            if (!$.fn.DataTable.isDataTable(tableElem)) {
                initRapportSection(sectionElem);
            }
        } else {
            sectionElem.find('.sub-tab.tab-pane').each(function () {
                if (!$.fn.DataTable.isDataTable($(this).find('.table-evenements'))) {
                    initRapportSection($(this));
                }
            });
        }
    } else {
        $('ul.nav-tabs li.active').removeClass('active');
        $('#' + idbtnrapport + ' ').parent('li').addClass('active');
        $('div.tab-content div.active').removeClass('active');
        sectionElem.addClass('active');
    }
});

function fct_filtre_appliquer_callback_rapport(tableElem) {
    return function (e) {
        var table = tableElem.DataTable();
        var bool_refresh = $(e.currentTarget).is('.appliquer-filtre');
        if (typeof (table) !== 'undefined') {
            if (table.settings()[0].jqXHR) {
                table.settings()[0].jqXHR.abort();
            }
            wait.start();
        }
        table.ajax.reload(function (data) {
            wait.stop();
            if (data !== undefined && data.data.length > 0) {
                $(".top-btn-actions-bar button[name^=\"btn-\"]:not([name^=\"btn-importer-valeurs-equilibration\"])").each(function (index, value) {
                    $(value).prop('disabled', false);
                });
            } else {
                $(".top-btn-actions-bar button[name^=\"btn-\"]:not([name^=\"btn-importer-valeurs-equilibration\"])").each(function (index, value) {
                    $(value).prop('disabled', true);
                });
            }

        }, bool_refresh);
    };
}

function supprimer_taj_rapport(tableElem, my_url) {
    var table = tableElem.DataTable();

    var identifiant = table.rows('.selected').data('id_route_inspection');

    var listeId = [];
    $.each(identifiant, function (idx, value) {
        var id = value['id_route_inspection'];
        if (id != '') listeId.push(id);
    });
    var idRapport = tableElem.data('id-rapport');

    var params = {
        id_rapport: idRapport,
        listeRoute: listeId
    };

    wait.start();

    $.ajax({
        type: "POST",
        url: my_url,
        contentType: "application/json",
        data: JSON.stringify(params),
        dataType: 'text',
        success: function (response) {
            infos.ajouterMessageToast({
                message: response,
                messageDuree: 5000
            });

            wait.stop();
            table.ajax.reload(null, false);

        }
    });

}


function export_xls_taj_rapport(tableElem, my_url) {
    var table = tableElem.DataTable();

    var unitesEvaluation = table.rows('.selected').data('id_ue');
    var listeIdUe = [];
    $.each(unitesEvaluation, function (idx, value) {
        var idUe = value['id_ue'];
        if (idUe != '') listeIdUe.push(idUe);
    });

    var idRapport = tableElem.data('id-rapport');

    buildFiltresSelectionContenu(tableElem);

    // DM: je tente d'alléger cette variable au lieu de la passer au complet dans le POST, sinon on a des problèmes quand on passe par le VPN
    var listeFiltresDef = tableElem.data('filtres');
    var listeFiltres = epurerListeFiltresPost(listeFiltresDef);
    var colonnesDef = tableElem.data('colonnesDef');

    //13000
    if ($('#query-builder').length != 0) {
        var listeFiltresQueryBuilder = $('#query-builder').queryBuilder('getSQL', false, true);
    }

    var params = {
        order: table.order(),
        listeIdUe: listeIdUe,
        listeFiltres: JSON.stringify(listeFiltres),
        listeFiltresQueryBuilder: JSON.stringify(listeFiltresQueryBuilder, null, 2),
        // 14692: ...id municipalité était null, On veut récupérer le id mun du sélecteur de municipalité
        // entre autre pour pouvoir exporter le excel du rapport des regroupements.
        idMunicipalite: $("#id_municipalite_sig").val() || $('#adm-liste-ville').val(),
        id_rapport: idRapport,
        colonnesDef: JSON.stringify(colonnesDef),
        date_courante: $('#gestion-semaine [name=date_courante]').val() // exemple pour Resp. exécution
    };

    //  On valide que les filtres qui sont requis ne soient pas vides avant de générer un rapport. C'est en cas par rapport dans la table rapport_filtre_x_rapport
    $.each(listeFiltresDef.champs, function (index, value) {
        if (value.parametres[0].bool_filtre_requis_pour_impression === true) {
            wait.stop();
            erreursAjax.afficherErreurChamps($('td[name="' + index + '"]'), 'projet', "Ce filtre est obligatoire pour l'impression", '');
            this.preventDefault();
        }
    });

    wait.start();

    $.ajax({
        type: "POST",
        url: my_url,
        contentType: "application/json",
        data: JSON.stringify(params),
        dataType: 'text',
        success: function (response) {
            infos.ajouterMessageToast({
                message: response,
                messageDuree: 5000
            });

            wait.stop();
        }
    });

}


// Test the api connector
function export_google_map_taj_rapport(tableElem) {
    wait.start();
    var listeIdUe = [];
    var table = tableElem.DataTable();
    var unitesEvaluation = table.rows('.selected').data('id_ue');

    $.each(unitesEvaluation, function (idx, value) {
        var idUe = value['id_ue'];
        if (idUe != '') listeIdUe.push(idUe);
    });
    navigator.geolocation.getCurrentPosition(function (position) {
        $.ajax({
            type: "POST",
            url: "/gestion-entreprise/gestion-rapport/export_google_map/",
            data: {
                'ues': listeIdUe.join(';'),
                'current_latitude': position.coords.latitude,
                'current_longitude': position.coords.longitude
            },
            dataType: 'json',
            success: function (response) {
                wait.stop();
                window.open(response.google_map_url, '_blank');
            },
        });
    }, function () {
    });


}

function inspection_ouvrir_fiche(tableElem) {

    var table = tableElem.DataTable();

    var evenements = table.rows('.selected').data('id_evenement');
    var listeEvenement = [];
    $.each(evenements, function (idx, value) {
        var idEvenement = value['id_evenement'];
        if (idEvenement != '') listeEvenement.push(idEvenement);
    });

    var params = {
        listeEvenement: listeEvenement,
    };

    $.ajax({
        type: "POST",
        url: "/gestion-entreprise/gestion-rapport/inspection-ouvrir-fiche/",
        data: JSON.stringify(params),
        dataType: 'json',
        success: function (response) {
            // 20307
            if (response.liste_url == 'evenement_maximun') {
                infos.ajouterMessageToast({
                    message: "Vous ne pouvez pas ouvrir plus de 25 fiches à la fois. Veuillez réduire la quantité d'évènements sélectionnés.",
                    messageDuree: 5000,
                    messageCouleur: 'red'
                });
            } else {
                $.each(response.liste_url, function (k, v) {
                    window.open(v, '_blank');
                });
            }

        },
    });

}



// spécifique au rapport Planification des inspections
//SVP ne pas supprimer car la fonction est utilisée dans la bd
// pour la confiugration des boutons de la table
function ai_clicked(objet, terme, a_faire) {
    var row = $(objet).closest('tr');
    var tableElem = row.closest('table');
    var tableFiltres = tableElem.data('table-filtres');

    //var tableElem2 = $('#table-evenements-2');
    var tableElem2 = $('.table-evenements[id^=DataTables]').not(tableElem);
    var tableFiltres2 = tableElem2.data('table-filtres');

    var idMunicipalite = row.attr('data-id_municipalite');
    var dateDebutCalcul = tableFiltres.find('[name=date_debut_calcul] input.form-control').val();

    var filtresMunicipalite = [{id: idMunicipalite}];

    var filtresUsage = getFiltreValeurs(tableElem, 'usage');
    var filtresInspectionComplete = getFiltreValeurs(tableElem, 'inspection_complete');
    var filtresResponsableJuridiction = getFiltreValeurs(tableElem, 'responsable_juridiction');
    var filtresBureau = getFiltreValeurs(tableElem, 'bureau');
    var filtresevenementouvert = getFiltreValeurs(tableElem, 'bool_evenement_ouvert_planification');
    var filtres_mrc = getFiltreValeurs(tableElem, 'mrc');
    var filtres_nb_logement = getFiltreValeurs(tableElem, 'nb_logement');
    var filtres_nb_locaux = getFiltreValeurs(tableElem, 'nb_locaux');
    var filtres_code_utilisation = getFiltreValeurs(tableElem, 'code_utilisation');
    var filtres_lien_physique = getFiltreValeurs(tableElem, 'lien_physique');
    var filtres_condition_inscription_extraction = getFiltreValeurs(tableElem, 'condition_inscription_extraction');
    // Note: dans les tables, le secteur d'inspection est le secteur geographique, le filtre porte donc ce nom
    var filtres_secteur_inspection = getFiltreValeurs(tableElem, 'secteur_geographique');
    var filtre_profil_evaluateur_responsable = getFiltreValeurs(tableElem, 'profil_evaluateur_responsable');


    var filtresTerme = [{id: terme}];
    var filtresAFaire = [{id: a_faire}];

    setFiltreValeurs(tableElem2, 'mrc', filtres_mrc);
    setFiltreValeurs(tableElem2, 'municipalite_cascade', filtresMunicipalite);
    setFiltreValeurs(tableElem2, 'usage', filtresUsage);
    setFiltreValeurs(tableElem2, 'inspection_complete', filtresInspectionComplete);
//10678 triggers change
    tableFiltres2.find('[name=date_debut_calcul] input.form-control').val(dateDebutCalcul).trigger('change');

    setFiltreValeurs(tableElem2, 'responsable_juridiction', filtresResponsableJuridiction);
    setFiltreValeurs(tableElem2, 'bureau', filtresBureau);
    setFiltreValeurs(tableElem2, 'terme', filtresTerme);
    setFiltreValeurs(tableElem2, 'ai_faire_avant_fin_contrat', filtresAFaire);
    setFiltreValeurs(tableElem2, 'bool_evenement_ouvert_planification', filtresevenementouvert);

    tableFiltres2.find('[name=nb_logement_debut]').val(filtres_nb_logement[0].debut).trigger('change');
    tableFiltres2.find('[name=nb_logement_fin]').val(filtres_nb_logement[0].fin).trigger('change');
    tableFiltres2.find('[name=nb_locaux_debut]').val(filtres_nb_locaux[0].debut).trigger('change');
    tableFiltres2.find('[name=nb_locaux_fin]').val(filtres_nb_locaux[0].fin).trigger('change');
    setFiltreValeurs(tableElem2, 'code_utilisation', filtres_code_utilisation);
    setFiltreValeurs(tableElem2, 'lien_physique', filtres_lien_physique);
    setFiltreValeurs(tableElem2, 'condition_inscription_extraction', filtres_condition_inscription_extraction);
    setFiltreValeurs(tableElem2, 'secteur_geographique', filtres_secteur_inspection);
    setFiltreValeurs(tableElem2, 'profil_evaluateur_responsable', filtre_profil_evaluateur_responsable);

    var boutonAppliquerFiltre = tableFiltres2.closest('.filtre-panneau').find('.appliquer-filtre');
    boutonAppliquerFiltre.click();
}

function ai_creer_clicked(objet) {
    var row = $(objet).closest('tr');
    var idMunicipalite = row.attr('data-id_municipalite');

    var idTypeEvenement = 31;
    var params = {id_municipalite: idMunicipalite};

    tenueAJourModal.ouvrirWizardNouvelEvenement(idTypeEvenement, params);

}


function ai_ouvrir_photos(objet) {
    var row = $(objet).closest('tr');
    var idMunicipalite = row.attr('data-id_municipalite');
    var idUe = row.attr('data-id_ue');

    var idevenement = row.attr('data-id_evenement');
    $('#div-photo').empty();
    if ($('#div-photo').is(':empty')) {
        wait.start();

        var params = {
            "date_evenement": dateEvenement,
            "id_ue": idUe
        };
        let success_cb = function (response) {
            $('#div-photo').html(response);
            var divPhoto = $('#exp-ue-photo');
            ajusterTailleImage(divPhoto.find('img'), '100px', '80px');
            initAceThumbnails('colorbox-photo');

            wait.stop();
            var babthi = divPhoto.find('a');
            $(babthi)[0].click();
        };
        call_ajax(`/gestion-roles/exp-ue/${idUe}/photos/`, 'GET', params, success_cb);
    }
}

function evenement_ouvert_clicked(objet) {
    var row = $(objet).closest('tr');

    var tableElem = row.closest('table');
    var tableFiltres = tableElem.data('table-filtres');

    var idUe = row.attr('data-id_ue');
    var filtresUe = [{id: idUe}];

    var filtresStatut = [{id: 99}];

    setFiltreValeurs(tableElem, 'unite_evaluation', filtresUe);
    setFiltreValeurs(tableElem, 'id_statut_evenement', filtresStatut);

    var boutonAppliquerFiltre = $('.appliquer-filtre');
    boutonAppliquerFiltre.click();

    return false;
}

function mutation_table_creer_enquete_callback(id_evenement) {
    let id_enquete;
    $.ajax({
        type: "POST",
        url: `/gestion-roles/mutations/creer_enquete_vente/${id_evenement}/`,
        dataType: 'json',
        async: false,
        success: function (response) {
            wait.stop()
            infos.ajouterMessageToast({
                message: response.msg,
                icone: 'fa-envelope-o ',
                iconeCouleur: 'green',
                messageDuree: 5000
            });
            if (response.id_enquete) {
                id_enquete = response.id_enquete;
            }
        }
    });
    return id_enquete;
}

function mutation_table_creer_enquete(objet) {
    // #18331
    let id_evenement = objet.dataset.id_evenement
    fenetreModal.modalMessage({
        enteteTitre: 'Attention',
        titre: "Créer une enquête de vente?",
        texteExplicatif: "Souhaitez-vous créer une enquête de vente pour cette mutation?",
        conteneur: "#page_content",
        taille: "grande",
        boutons: {
            0: {
                label: " Oui et revenir au tableau des mutations ",
                id: "",
                class: "btn btn-success",
                action: function () {
                    wait.start();
                    mutation_table_creer_enquete_callback(id_evenement);
                    refreshDatatables();
                    fenetreModal.fermerModalAlerteDivs();
                }
            },
            1: {
                label: " Oui et ouvrir l'enquête de vente ",
                id: "",
                class: "btn btn-success",
                action: function () {
                    wait.start();
                    let id_enquete = mutation_table_creer_enquete_callback(id_evenement);
                    fenetreModal.fermerModalAlerteDivs();
                    refreshDatatables();
                    wait.start()
                    tenueAJourModal.ouvrirWizardEvenement(id_enquete);
                }
            },
            2: {
                label: " Annuler ",
                id: "",
                class: "btn",
                action: function () {
                    fenetreModal.fermerModalAlerteDivs();
                }
            }
        }
    });

}

function createFilterList(inputList) {
    return inputList.map(value => ({id: value}));
}

async function delais_traitement_heures_clicked(objet, estToutesLignes = false) {
    const row = $(objet).closest('tr');
    const tableElem = estToutesLignes
        ? $(row).closest('.dataTables_scrollFoot').siblings('.dataTables_scrollBody').find('table')
        : $(row).closest('table');

    var tableElem2 = $('.table-evenements[id^=DataTables]').not(tableElem);
    var tableFiltres2 = tableElem2.data('table-filtres');

    var id_projet = [];
    var id_lot = [];
    var id_sous_lot = [];
    var idMunicipaliteList = [];
    wait.start();

    // Important laisse le repaint se faire avant de continuer
    await new Promise(resolve => requestAnimationFrame(resolve));

    try {
        const rowsInfo = get_rows_info_for_delais_traitement(row, tableElem, estToutesLignes);
        const params = {
            'ids_municipalites': rowsInfo.municipalitesIds,
            'ids_types_evenement': rowsInfo.typesEvenementIds,
            'date_transaction': rowsInfo.dateTransaction,
            'usage_depense': JSON.stringify(rowsInfo.usageDepense),
            'est_toutes_lignes': estToutesLignes
        };

        const response = await $.ajax({
            type: "POST",
            url: `/gestion-roles/rapports/donnees-indicateurs/`,
            data: params,
            dataType: 'json'
        });

        if (response && response.id_projet) {
            id_projet = response.id_projet;
            id_lot = response.id_lot;
            id_sous_lot = response.id_sous_lot;
            idMunicipaliteList = response.id_municipalite;
        }

        let filtresProjet = createFilterList(id_projet);
        let filtresMunicipalite = createFilterList(idMunicipaliteList);
        let filtresLot = createFilterList(id_lot);
        let filtresSousLot = createFilterList(id_sous_lot);

        var filtresDepense = getFiltreValeurs(tableElem, 'categorie_depense');
        var filtresEmploye;

        if (estToutesLignes) {
            filtresEmploye = createFilterList(rowsInfo.employesIds);
        } else {
            filtresEmploye = [{ id: rowsInfo.employesIds }];
        }

        var divElement = tableFiltres2.find("div[name='date_transaction']");
        var inputElement = divElement.find("input[name='date-range-picker']");
        inputElement.val(rowsInfo.dateTransaction).trigger('change');

        setFiltreValeurs(tableElem2, 'projet', filtresProjet);
        setFiltreValeurs(tableElem2, 'lot', filtresLot);

        if (id_sous_lot !== undefined && id_sous_lot !== null) {
            setFiltreValeurs(tableElem2, 'sous_lot', filtresSousLot);
        }

        setFiltreValeurs(tableElem2, 'municipalite_lot', filtresMunicipalite);
        setFiltreValeurs(tableElem2, 'employe', filtresEmploye);
        setFiltreValeurs(tableElem2, 'categorie', filtresDepense);

        var boutonAppliquerFiltre = tableFiltres2.closest('.filtre-panneau').find('.appliquer-filtre');
        boutonAppliquerFiltre.click();

    } finally {
        wait.stop();
    }
}


function get_rows_info_for_delais_traitement(row, tableElem, est_toutes_lignes) {
    let municipalitesIds;
    let employesIds;
    let typesEvenementIds;
    let tableFiltres = tableElem.data('table-filtres');
    const id_rapport = tableElem.data('id-rapport')
    const dateTransaction = tableFiltres.find("input[name='date-range-picker']").val();
    const usagedepense = getFiltreValeurs(tableElem, 'usage_depense');
    const usagedepense_list = usagedepense.map(item => item.id);
    let idTypeEvenement = '';
    let typeEvenement = []

    if (est_toutes_lignes) {
        let municipaliteIdsSet = new Set();
        let employeIdsSet = new Set();
        let typeEvenementIdsSet = new Set();
        const tableRows = tableElem.find('tbody').children('tr');

        for (let index = 0; index < tableRows.length; index++) {
            idTypeEvenement = ''
            let currentRow = $(tableRows[index]);
            municipaliteIdsSet.add(currentRow.attr('data-id_municipalite'));
            employeIdsSet.add(currentRow.attr('data-id_employe'));

            if (id_rapport === RAPPORT.delais_moyens_traitement) {
                idTypeEvenement = currentRow.attr('data-id_type_evenement');
                if (idTypeEvenement !== undefined) {
                    typeEvenementIdsSet.add(idTypeEvenement)
                }
            }
        }

        if (id_rapport === RAPPORT.delais_moyens_traitement) {
            typeEvenement = getFiltreValeurs(tableElem, 'type_evenement_delai')
        }
        if (typeEvenement.length > 0 && typeEvenementIdsSet.length === 0) {
            for (let index_type = 0; index_type < typeEvenement.length; index_type++) {
                typeEvenementIdsSet.add(typeEvenement[index_type].id);
            }
        }

        municipalitesIds = JSON.stringify(Array.from(municipaliteIdsSet));
        employesIds = Array.from(employeIdsSet);
        typesEvenementIds = JSON.stringify(Array.from(typeEvenementIdsSet));

    } else {
        municipalitesIds = row.attr('data-id_municipalite');
        employesIds = row.attr('data-id_employe');

        if (id_rapport === RAPPORT.delais_moyens_traitement) {
            typesEvenementIds = row.attr('data-id_type_evenement');
        }

        if (typeEvenement.length > 0 && typesEvenementIds === undefined) {
            typesEvenementIds = typeEvenement[0].id;
        }
    }

    return {
        'municipalitesIds': municipalitesIds,
        'typesEvenementIds': typesEvenementIds,
        'dateTransaction': dateTransaction,
        'usageDepense': usagedepense_list,
        'employesIds': employesIds
    }
}


function details_liste_attestation_clicked(objet, type_attestation, nom_ligne=null) {
    var row = $(objet).closest('tr');
    var tableElem;

    if (nom_ligne !== null) {
        tableElem = row.closest('table');
        let idMunicipaliteList = [row.data('id_municipalite')];
        let filtresMunicipalite = createFilterList(idMunicipaliteList);
        setFiltreValeurs(tableElem, 'municipalite_cascade', filtresMunicipalite);
    }
    else {
        tableElem = $(row).closest('.dataTables_scrollFoot').siblings('.dataTables_scrollBody').find('table')
    }
    var table = tableElem.DataTable();

    buildFiltresSelectionContenu(tableElem);

    var idRapport = tableElem.data('id-rapport');
    var listeFiltresDef = tableElem.data('filtres');
    var listeFiltres = epurerListeFiltresPost(listeFiltresDef);
    var colonnesDef = tableElem.data('colonnesDef');

    var params = {
        bool_attestation_verification: type_attestation,
        nom_ligne: nom_ligne,
        order: table.order(),
        listeFiltres: JSON.stringify(listeFiltres),
        id_rapport: idRapport,
        colonnesDef: JSON.stringify(colonnesDef),
        date_courante: $('#gestion-semaine [name=date_courante]').val()
    };

    wait.start();

    $.ajax({
        type: "POST",
        url: "/gestion-entreprise/gestion-rapport/export-excel-indicateur-attestation/",
        contentType: "application/json",
        data: JSON.stringify(params),
        dataType: 'text',
        success: function (response) {
            infos.ajouterMessageToast({
                message: response,
                messageDuree: 5000
            });
            wait.stop();
        }
    });

}

function ajouter_historique_liste_attestation_clicked(objet, type_attestation, nom_ligne) {
    var row = $(objet).closest('tr');
    var tableElem = row.closest('table');
    var table = tableElem.DataTable();

    let idMunicipaliteList = [row.data('id_municipalite')];
    let filtresMunicipalite = createFilterList(idMunicipaliteList);
    setFiltreValeurs(tableElem, 'municipalite_cascade', filtresMunicipalite);

    buildFiltresSelectionContenu(tableElem);

    var idRapport = tableElem.data('id-rapport');
    var listeFiltresDef = tableElem.data('filtres');
    var listeFiltres = epurerListeFiltresPost(listeFiltresDef);
    var colonnesDef = tableElem.data('colonnesDef');

    var params = {
        bool_attestation_verification: type_attestation,
        nom_ligne: nom_ligne,
        order: table.order(),
        listeFiltres: JSON.stringify(listeFiltres),
        id_rapport: idRapport,
        colonnesDef: JSON.stringify(colonnesDef),
        date_courante: $('#gestion-semaine [name=date_courante]').val()
    };

    wait.start();

    $.ajax({
        type: "POST",
        url: "/gestion-entreprise/gestion-rapport/ajouter-historique-indicateur-attestation/",
        contentType: "application/json",
        data: JSON.stringify(params),
        dataType: 'json',
        success: function (response) {

            var input = document.createElement('input');
            input.type = 'hidden';
            input.name = 'listeUe';
            input.value = JSON.stringify(response);

            var form = $('#btn_explorer_form');
            form.find('.fields').append(input);
            form.attr('action', `/?idModule=31&decoche_ue=true`);
            form.submit();
            form.attr('action', '');
            form.find('.fields').html('');

            wait.stop();
        }
    });

}


function initSubmitFormRouteInspection() {
    $('#form-route-inspection').off('submit').on('submit', function(e) {
        e.preventDefault();
        var $this = $(this)
        var $modal = $('#modal-route-inspection')
        var success_cb = function(resp) {
            $modal.modal('hide')
            infos.ajouterMessageToast({
                message: resp.msg,
                messageDuree: 1500,
                icone: 'fa-check-circle-o',
                iconeCouleur: 'green'
            });
            $('.appliquer-filtre').click()
        }
        var error_cb = function(xhr, textStatux, error) {
            var $modalContainer = $('.modal-container')
            $modalContainer.find('#modal-route-inspection').empty()
            $modalContainer.find('#modal-route-inspection').html(xhr.responseText)
            initFormRouteInspection()
        }
        call_ajax($this.attr('action'), $this.attr('method'), $this.serialize(), success_cb, error_cb)
    })
}

function initFormRouteInspection() {
    var $modal = $('#modal-route-inspection')
    initDatepickerWithOptions($modal.find('[name="date_debut_prevue"]'), {
        autoUpdateInput: false,
        ranges:{
            "Aujourd'hui": [moment(), moment()]
        },
        showCustomRangeLabel: false,
        parentEl: $modal.find('.date-debut-container'),
    })
    initDatepickerWithOptions($modal.find('[name="date_fin_prevue"]'), {
        autoUpdateInput: false,
        ranges:{
            "Aujourd'hui": [moment(), moment()]
        },
        showCustomRangeLabel: false,
        parentEl: $modal.find('.date-fin-container'),
    })
    $modal.find('select.select2').select2({allowClear: true,})
    initSubmitFormRouteInspection()
}

function initFormParametresCalcul(modal) {
        initSelect2($(modal));
        init_date_picker($(modal));
        $(modal).find('#id_municipalite').on('change', function () {
            var id_mun = $(this).val();
            if (id_mun !== '') {
                let url = `/gestion-roles/date-role/municipalite/${id_mun}/`;
                let success_cb = function (response) {
                    var champDateRole = $(modal).find('#id_date_role');
                    champDateRole.empty();
                    champDateRole.append('<option value=""></option>');
                    $.each(response, function (i, listDateRole) {
                        champDateRole.append($('<option>', {
                            value: listDateRole.id_choix,
                            text: listDateRole.titre
                        }));
                    });
                    champDateRole.select2({allowClear: true});
                };
                call_ajax(url, 'GET', null, success_cb);
            }
        });

}
function ouvrirModalParametresCalcul($this) {
    let url = $($this).data('url');
    var modal = $('#modal-rafraichir-donnees');
    let success_cb = function(resp) {
        $(modal).find('.modal-body').empty().html(resp);
        $(modal).modal('show');
        initFormParametresCalcul(modal);
        $(modal).find('#btn-save-modal-entrepot-analyse').on('click', function () {
            let url = $(modal).find('form').attr('action');
            let data = $(modal).find('form').serialize();
            let success_cb_save = function (response) {
                if (response.reponse == 'ok') {
                    infos.ajouterMessageToast({
                        message: 'Un courriel vous sera envoyé lorsque le chargement sera complété.',
                        messageDuree: 3000,
                        messageCouleur: 'green'
                    });
                } else {
                    if (response.reponse == 'validation') {
                        infos.ajouterMessageToast({
                            message: response.validation,
                            messageDuree: 0
                        });
                    } else {
                        infos.ajouterMessageToast({
                            message: "Une erreur s\'est produite. Veuillez contacter l\'administration du système",
                            messageDuree: 1500,
                            messageCouleur: 'red'
                        });
                    }
                }
            };

            let error_cb = function(xhr, textStatux, error){
                $(modal).find('.modal-body').empty().html(xhr.responseText);
                initFormParametresCalcul(modal);
            };
            $('#modal-rafraichir-donnees-confirm').modal('show');
            $('#btn-save-modal-entrepot-analyse-confirm').off('click').on('click', function() {
                $(this).closest(".modal").modal("hide");
                $('body').addClass('modal-open');
                call_ajax(url, 'POST', data, success_cb_save, error_cb);
            });
        });
    };
    call_ajax(url, 'GET', null, success_cb);
}

function setWarningMsg() {
    let eventChecked = get_listeIdEvenement();
    let eventProcessed = document.getElementById("list_mode_deconnecte_events").value;
    var listeCommune = eventChecked.filter(id => eventProcessed.includes(id));
    if (listeCommune.length > 0) {
        $('#mode-deconnecte-warning').html(`Vous avez sélectionné ${listeCommune.length} événement${listeCommune.length > 1 ? 's' : ''}
         qui ont déjà été téléchargés. Veuillez d'abord aller les supprimer sur l'application mobile avant de pouvoir
          les télécharger de nouveau. <br><br>`);
    }

}

function ouvrirModalTelechargerDossierConfirm() {
    setWarningMsg();
    $('#modal-telecharger-mode-deconnecte-confirm').modal('show');

    $('#modal-telecharger-mode-deconnecte-confirm').off('hidden.bs.modal').on('hidden.bs.modal', function () {
        setTimeout(function () {
            $('body').removeClass('modal-open');

            // Restaurer position: relative qu'Ace avait mis et que Bootstrap a effacé
            $('body').css('position', 'relative');

            // Forcer Ace à recalculer les hauteurs scrollables
            $(window).trigger('resize');
        }, 50);
    });

    $('#btn-modal-telecharger-mode-deconnecte-confirm').off('click').on('click', function () {
        let listeEvenement = get_listeIdEvenement();
        $(this).closest(".modal").modal("hide");
        let url = '/gestion-roles/editeur-fiche/download/';
        let success_cb_save = function (response) {
            if (response.reponse == 'ok') {
                infos.ajouterMessageToast({
                    message: 'Un courriel vous sera envoyé dans quelques minutes avec les événements téléchargés.',
                    messageDuree: 5000,
                    messageCouleur: 'green'
                });
            } else {
                if (response.reponse == 'validation') {
                    infos.ajouterMessageToast({
                        message: response.validation,
                        messageDuree: 0
                    });
                } else {
                    infos.ajouterMessageToast({
                        message: "Une erreur s\'est produite. Veuillez contacter l\'administration du système",
                        messageDuree: 1500,
                        messageCouleur: 'red'
                    });
                }
            }
        };
        call_ajax(url, 'GET', {'ids_evenement': listeEvenement}, success_cb_save);
    });
    $("body").off("click", ".btn-close-modal-overlay").on("click", ".btn-close-modal-overlay", function () {
        $(this).closest(".modal").modal("hide");
    });
}

function ouvrirModalTravailTermineDossierConfirm() {
    $('#modal-travail-termine-mode-deconnecte-confirm').modal('show');
    $('#modal-travail-termine-mode-deconnecte-confirm').off('click').on('click', function () {
        let listeEvenement = get_listeIdEvenement();
        $(this).closest(".modal").modal("hide");
        $('body').addClass('modal-open');
        let url = '/gestion-roles/editeur-fiche/forcer-travail-complete-mode-deconnecte/';
        let success_cb_save = function (response) {
            if (response.reponse == 'ok') {
                infos.ajouterMessageToast({
                    message: 'Traitement complété',
                    messageDuree: 5000,
                    messageCouleur: 'green'
                });
            } else {
                if (response.reponse == 'validation') {
                    infos.ajouterMessageToast({
                        message: response.validation,
                        messageDuree: 0
                    });
                } else {
                    infos.ajouterMessageToast({
                        message: "Une erreur s\'est produite. Veuillez contacter l\'administration du système",
                        messageDuree: 1500,
                        messageCouleur: 'red'
                    });
                }
            }
        };
        call_ajax(url, 'GET', {'ids_evenement': listeEvenement}, success_cb_save);
    });
    $("body").off("click", ".btn-close-modal-overlay").on("click", ".btn-close-modal-overlay", function () {
        $(this).closest(".modal").modal("hide");
        $('body').addClass('modal-open');
    });
}
